import { Skeleton, Container } from '@mui/material';

const ProcessoLoading = () => {
    return (
        <Container style={{ display: 'flex', flexDirection: 'row', gap: '26px', paddingTop: '40px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '30%' }}>
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '16px'
                }}>
                    <Skeleton variant="rectangular" width="100%" height={350} sx={{ mb: 2 }} />

                    <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
                    <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '16px',
                width: '70%'
            }}>
                {[1, 2, 3].map((item) => (
                    <div key={item} style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        padding: '16px'
                    }}>
                        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />

                        <Skeleton variant="rectangular" width="100%" height={370} sx={{ mb: 2 }} />
                    </div>
                ))}
            </div>
        </Container>
    );
}

export default ProcessoLoading;
